var _rect, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissionCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.33301,
    y: 2.66675,
    width: 21.3333,
    height: 26.6667,
    rx: 3.33333,
    fill: "#DED2A0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6663 16.0002C22.6663 19.6821 19.6816 22.6668 15.9997 22.6668C12.3178 22.6668 9.33301 19.6821 9.33301 16.0002C9.33301 12.3183 12.3178 9.3335 15.9997 9.3335C19.6816 9.3335 22.6663 12.3183 22.6663 16.0002Z",
    fill: "#FEFDF5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66602 6.66691C6.66602 5.19415 7.85992 4.00024 9.33268 4.00024H22.666C24.1388 4.00024 25.3327 5.19415 25.3327 6.66691V25.3336C25.3327 26.8063 24.1388 28.0002 22.666 28.0002H9.33268C7.85992 28.0002 6.66602 26.8063 6.66602 25.3336V6.66691ZM9.33268 4.93358H22.666C23.6233 4.93358 24.3993 5.70962 24.3993 6.66691V25.3336C24.3993 26.2909 23.6233 27.0669 22.666 27.0669H9.33268C8.37539 27.0669 7.59935 26.2909 7.59935 25.3336V6.66691C7.59935 5.70962 8.37539 4.93358 9.33268 4.93358Z",
    fill: "#A48300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 12C18.1741 12.0403 19.9242 13.8139 19.9242 15.9977C19.9242 18.2067 18.1334 19.9974 15.9244 19.9974C13.748 19.9974 11.9785 18.259 11.9268 16.095C12.4577 16.8478 13.3333 17.3403 14.3245 17.3403C15.9444 17.3403 17.2575 16.0269 17.2577 14.4071C17.2577 13.4103 16.7599 12.53 15.9999 12Z",
    fill: "#A48300"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionCard);
export default __webpack_public_path__ + "static/media/mission-card.f0788acf1667c14cc6d68575051be091.svg";
export { ForwardRef as ReactComponent };